import React from 'react';
import proptypes from 'prop-types';
import { Tile as TileElement, TileContent, TileText } from '@one-thd/sui-atomic-components';
import { Tooltip } from '../tooltip/tooltip';
import { AvailabilityTooltipContent } from '../tooltip/availability-tooltip-content';

const { string, shape, bool, func } = proptypes;

export const TileComponent = ({
  value,
  isSelected,
  isAvailable,
  isFabricType,
  onClick,
  onTileMouseEnter,
  onTileMouseLeave,
  anchorRef,
  hoveredCombinationDetails,
  onPopoverClose,
  showMainTooltip,
  showUnavailableTooltip,
  shouldShowOOSTTooltip,
  isOOS,
  isUnavailable,
  unavailableTooltipMessage,
  oosTooltipMessage

}) => {

  const hasUnavailableOrOOSTooltip = unavailableTooltipMessage || oosTooltipMessage;

  const unavailable = hasUnavailableOrOOSTooltip
    ? ((isUnavailable || isOOS) && !isFabricType)
    : (!isAvailable && !isFabricType);

  const shouldLineThrough = unavailableTooltipMessage ? (!isOOS && !isAvailable) : (!isAvailable && !isFabricType);

  const tileChild = (
    <div onMouseEnter={onTileMouseEnter} onMouseLeave={onTileMouseLeave}>
      <TileElement
        onClick={onClick}
        aria-label={value}
        value={value}
        selected={isSelected}
        unavailable={unavailable}
        data-testid="text-tile"
      >
        <TileContent>
          <TileText decoration={shouldLineThrough && 'line-through'}>
            {value}
          </TileText>
        </TileContent>
      </TileElement>
    </div>
  );

  const shouldShowPopover = (showMainTooltip || showUnavailableTooltip || shouldShowOOSTTooltip) && anchorRef?.current;

  return (
    <>
      {tileChild}
      {shouldShowPopover && (
        <Tooltip
          key={`popover-${value}`}
          open={anchorRef?.current}
          anchorEl={anchorRef?.current}
          onClose={onPopoverClose}
          placement={showMainTooltip ? 'top' : 'bottom'}
        >
          <AvailabilityTooltipContent
            showMainTooltip={showMainTooltip}
            showUnavailableTooltip={showUnavailableTooltip}
            hoveredCombinationDetails={hoveredCombinationDetails}
            shouldShowOOSTTooltip={shouldShowOOSTTooltip}
            unavailableTooltipMessage={unavailableTooltipMessage}
            oosTooltipMessage={oosTooltipMessage}
          />
        </Tooltip>
      )}
    </>
  );
};

TileComponent.propTypes = {
  value: string.isRequired,
  isSelected: bool.isRequired,
  isAvailable: bool.isRequired,
  isFabricType: bool,
  onClick: func.isRequired,
  onTileMouseEnter: func.isRequired,
  onTileMouseLeave: func.isRequired,
  showMainTooltip: bool,
  showUnavailableTooltip: bool,
  anchorRef: shape({}),
  hoveredCombinationDetails: shape({}),
  onPopoverClose: func.isRequired,
  shouldShowOOSTTooltip: bool,
  isOOS: bool,
  isUnavailable: bool,
  unavailableTooltipMessage: string,
  oosTooltipMessage: string,
};

TileComponent.defaultProps = {
  isFabricType: false,
  showMainTooltip: false,
  showUnavailableTooltip: false,
  anchorRef: null,
  hoveredCombinationDetails: {},
  shouldShowOOSTTooltip: false,
  isOOS: false,
  isUnavailable: false,
  unavailableTooltipMessage: '',
  oosTooltipMessage: '',
};